import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormField } from '@models/client-intake';
import { CoreUploadComponent } from '@core/ui';

import { FileUploadFormControl } from './file-input-field.types';

@Component({
	selector: 'app-file-input-field',
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, CoreUploadComponent],
	templateUrl: './file-input-field.component.html',
})
export class FileInputFieldComponent {
	@Input() field!: FormField;
	@Input() control!: FileUploadFormControl;
}
